module.exports = __webpack_public_path__ + "static/media/twitter.7a39d539.png";